import TableList from "@components/templates/tablelist";
import { HttpGetRoleList,HttpDeleteRole } from '@/service/department/rolemanage.js'
import { mapGetters } from "vuex";
import comIndex from './update'

export default {
    mixins: [TableList],
    components: {
        comIndex,
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {},
            exportdata: {},
            Searchs: {
                show: true,
            },
            Plugins: { show: true },
        };
    },
    methods: {
        ajaxRequest: HttpGetRoleList,
        handleOperates(params, type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(",")) + "";
                if (!params.length)
                    return this.$VMessage.warning(
                        this.$t("global.common.choose_one", {
                            defaultValue: "请选择至少一条数据",
                        })
                    );
            }
            switch (type) {
                case "query":
                    this.operate = {
                        title: this.$t('global.common.query', { defaultValue: '查看' }),
                        show: true,
                        width: 1200,
                        component: "comIndex",
                        activeids: params,
                        querytype: 'query',
                        showFooter: false
                    }
                    break;
                case "add":
                    this.$router.push({
                        name: "roleManageDetail",
                        params: { type: "add" },
                    });
                    break;
                case "edit":
                    this.$router.push({
                        name: "roleManageDetail",
                        params: { type: "edit" },
                        query: { id: params },
                    });
                    break;
                case "delete":
                    this.operate = {
                        show: true,
                        alert: "error",
                        width: 460,
                        params: { ids: params },
                        title: this.$t("global.common.delete", {
                            defaultValue: "删除",
                        }),
                        ajaxRequest: HttpDeleteRole,
                        desc: this.$t("fbb.localemanage.confirm_delete", {
                            defaultValue: "删除后不可恢复，是否确认删除？",
                        }),
                        formdata: [
                            {
                                label: this.$t("global.common.notes", {
                                    defaultValue: "备注",
                                }),
                                tag: "vTextarea",
                                key: "remark",
                                span: 24,
                                labelWidth: 60,
                                required: false,
                            },
                        ],
                    };
                    break;
                // case "import":
                //     this.operate = {
                //         show: true,
                //         title: this.$t("fbb.alloment.import_data", {
                //             defaultValue: "导入数据",
                //         }),
                //         width: 460,
                //         showFooter: false,
                //         name: "multipartFile",
                //         component: "compUpload",
                //         ajaxRequest: HttpImportMarkUpRate,
                //         download: () => {
                //             this.handleWebfs(
                //                 HttpDownloadMarkUpRateTemplate,
                //                 {},
                //                 "download"
                //             );
                //         },
                //     };
                //     break;
                // case "export":
                //     this.handleWebfs(
                //         process.env.VUE_APP_APIURL_FBB +
                //             "/api/v2/truckRate/export",
                //         this.formData,
                //         {
                //             executor: "request",
                //             download: true,
                //             method: "get",
                //         }
                //     );
                //     break;
            }
        },
        getOperateNodeMap(row) {
            const { id } = row;
            return [
                {
                    label: this.$t("global.common.edit", {
                        defaultValue: "编辑",
                    }),
                    show: true,
                    params: id,
                    operate: "edit",
                },
                {
                    label: "查看",
                    show: true,
                    params: id,
                    operate: "query",
                },
                {
                    label: this.$t("global.common.delete", {
                        defaultValue: "删除",
                    }),
                    show: true,
                    params: id,
                    operate: "delete",
                },
            ];
        },
    },
    computed: {
        ...mapGetters("dictionary", ["getBillcusorgList"]),
        ToolsData() {
            return [
                {
                    name: "添加",
                    operate: "add",
                    theme: "primary",
                },
            ];
        },
        SearchsData() {
            return [
                {
                    label: "角色名称",
                    key: "CN_name",
                    show: true,
                    tag: "Input",
                },
                {
                    label: "备注",
                    key: "CN_description",
                    show: true,
                    tag: "Input",
                },
            ];
        },
        columns() {
            return [
                {
                    type: "selection",
                    width: 40,
                    align: "center",
                    formName: "id",
                },
                {
                    title: this.$t("global.common.operation", {
                        defaultValue: "操作",
                    }),
                    width: 90,
                    render: this.getOperateNodes,
                },
                {
                    title: "角色名称",
                    key: "name",
                },
                {
                    title: "备注",
                    key: "description",
                },
                {
                    title: "创建时间",
                    key: "createdAt",
                },
                {
                    title: "更新时间",
                    key: "updatedAt",
                },
            ];
        },
    },
};
